import React, { Component } from 'react';
import {
  ColorButton,
  SearchContainer,
  SortContainer,
  Divider,
  RentalUnitModal,
  AddPropertyModal,
  DeleteModal,
  EmptyStateContainer,
  AddTenantModal,
  SortAlphabetically,
} from '../../../../neoverv';
import { TenantRecordRow, PageHeader } from '../../../elements/index';
import {
  getRentalUnitTenants,
  setCurrentTenant,
  updateFilteredList,
  DeleteUnit,
  loadingTenantsData
} from '../../../../redux/action/Tenant/TenantActions';
import {
  setRefreshTenantDocumentsData
} from '../../../../redux/action/General/generalActions';
import { connect } from 'react-redux';
import UnitsIcon from '../../../../assets/images/module/general/UnitsIcon.svg';
import BlueUnitsIcon from '../../../../assets/images/module/general/BlueEmptyTenant.svg';
import moment from 'moment';
import Autoload from '../../../../neoverv/Autoload';
import { Button, ButtonGroup } from 'react-bootstrap';
import { Skeleton } from '@mantine/core';
import AddPropertyTypeModal from '../../../../neoverv/components/Module/General/CustomModal/AddPropertyTypeModal';
import dayjs from 'dayjs';
import TenantDataHandler from '../../../../neoverv/helpers/DataHandler/Tenant';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
const {
  filterBySearchBarRentalTenants,
  deleteRecord,
  checkProperty,
  mergeArrayByProperty,
  nestedAlphabeticSort,
  filterTenantsAndUnits,
  filterByDateUtility,
} = Autoload.MainHelper;

class FilteredTenantsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addUnitModal: false,
      deleteUnitModal: false,
      editUnit: false,
      editUnitModal: false,
      currentUnit: {},
      ascendingOrder: false,
      searchValue: '',
      focus: false,
      showAllTenants: false,
      addPropertyModal: false,
      rentalUnit: [],
      rentalTenants: [],
      addTenantModal: false,
      currentRentalUnitId: '',
      TenantPostAddTenant: false,
      skeletonLoading: false,
      addPropertyTypeModal: false,
      selectedPropertyType: '',
      emptyTenantGapsData: {
        moveIn: '',
        moveOut: ''
      },
      emptyTenantEdit: false,
      rentalUnits: []
    };
  }

  componentDidMount() {
    console.log('component did mount ');

    //loader
    var loader = document.getElementById('hello-housing-loader');
    if(loader) loader.style.display = 'none';
    this.props.propertySelected && this.props.propertySelected.id !== undefined && this.setState({skeletonLoading: true});

    //call api
    this.props.getRentalUnitTenants([]);
    this.bind_rental_unit_list_data();
  }

  componentDidUpdate(){
    if(this.props.refreshTenantDocumentsData){
      this.bind_rental_unit_list_data();
      this.props.setRefreshTenantDocumentsData(null);
    }

    if(this.props.updateRentalUnitsInState){
      this.setState({rentalUnits: []},()=> {
        this.bind_rental_unit_list_data();
        this.props.setUpdateRentalUnitsInState(false);
      });
    }
  }

  getIsOwnerMode = () => {
    return this.props.location.pathname.includes('/condominiumAssociation');
  };

  showAllTenantFunction = (value) => {
    this.setState({
      TenantPostAddTenant: value,
    });
  };

  bind_rental_unit_list_data = () => {
    this.props.loadingTenantsData(true);
    let propertyid = this.props.propertySelected && this.props.propertySelected.id;
    
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'rentalUnits?offset=0&fetch=100&propertyId=' + propertyid,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_get_list_rental_unit',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    );
  };

  ChangeDateFormat = (dateString) => {
    if(!dateString) return '';
    const dateArray = dateString.split('.');
    return `${dateArray[1]}.${dateArray[0]}.${dateArray[2]}`;
  };

  handle_get_list_rental_unit = (response) => {
    if (response.result === null || response?.result?.length === 0) {
      this.ShowLoader();
      this.props.loadingTenantsData(false);
    }

    this.props.getRentalUnitTenants([]);
    
    if (response.status === false) {
      this.props.loadingTenantsData(false);
      if(response.message === 'NOT_FOUND'){
        this.setState({rentalUnits: []});
        this.ShowLoader(); 
      }
    } else {
      this.setState({rentalUnits: response.result.map((ru) => 
        (
          {
            id: checkProperty(ru, 'id'),
            name: checkProperty(ru, 'name'),
            size: checkProperty(ru, 'space'),
            propertyId: checkProperty(ru, 'propertyId'),
            type: ru?.rentalUnitType,
            utilitySpace: ru?.utilitySpace,
            isUtilityBillingEnabled: ru?.isUtilityBillingEnabled,
            tenantsData: [],
          }
        ))
      }, ()=> {
        if(response?.result?.length > 0){
          const isOwnerMode = this.getIsOwnerMode();

          response.result.map((ru, index) => {
            const isEol = index === (response?.result?.length - 1);

              let url = isOwnerMode ? `${Autoload.Setting.property_api_base_url}condominiumOwners?offset=0&fetch=100&rentalUnitId=${ru.id}` : `${Autoload.Setting.property_api_base_url}tenants?offset=0&fetch=100&rentalUnitId=${ru.id}`;
              Autoload.HttpRequestAxios.HttpRequest(
                url,
                'GET', null, null, false, true, false, this, 'handle_get_list_rental_tenants',
                {
                  eol: isEol,
                  rentalUnitId: ru.id 
                },
                false, '', { Authorization: Autoload.Utils.getAuthToken() }, true
              );
          });
        } else {
          this.ShowLoader();
        }
      });
    }
  };

  handle_get_list_rental_tenants = (response) => {
    const targetRentalUnitId = response?.other?.rentalUnitId; 
    const isOwnerMode = this.getIsOwnerMode();
    let tenantsData = [];

    console.log('handle_get_list_rental_tenants response: ', response);

    if (response?.result?.length > 0) {
      // Map CondoOwner attributes to standard Tenant attributes 
      if (isOwnerMode) {
        response.result = response.result.map((item) =>
          ({
              ...item,
              fullName: item?.name,
              moveInDate: item?.ownershipStartedOn,
              moveOutDate: item?.ownershipEndedOn,
              vacant: false 
          })
        );
      }

      let dashMoveOut = response.result.filter((item) => item.moveOutDate === null || item.moveOutDate === '');
      let filledMovedout = response.result.filter((item) => item.moveOutDate !== null && item.moveOutDate !== '');
      filledMovedout.map((item) => dashMoveOut.push(item));
      
      tenantsData = [...dashMoveOut];
      let isFirstVacantFound = false;
      let firstOriginalDataIndex;

      tenantsData = response.result.map((tenant, idx) => {
        let isVacant = tenant.vacant;
        let current = false;

        if (
          (dayjs(tenant.moveInDate).isBefore(dayjs()) || dayjs(tenant.moveInDate).isSame(dayjs()))
          && 
          (tenant.moveOutDate === null || dayjs(tenant.moveOutDate).isAfter(dayjs()) || dayjs(tenant.moveOutDate).isSame(dayjs()))
        ) { 
          firstOriginalDataIndex = idx;
          current = true;
          isFirstVacantFound = true;
        } else if(tenant.vacant && tenant.moveInDate === null && tenant.moveOutDate === null && response?.result?.length === 1){
          current = true;
        }

        return TenantDataHandler.setTenantFormData(tenant, current);
      });

      if (tenantsData.length === 1 && tenantsData[0].vacant == true) {
        // do nothing
      } else if (firstOriginalDataIndex !== 0 && firstOriginalDataIndex !== undefined) {
        let moveoutDate = tenantsData[firstOriginalDataIndex].out;
        if(moveoutDate) {
           let dateCompare = moment(this.ChangeDateFormat(moveoutDate)).isSameOrAfter(moment(new Date()));
           if (dateCompare === false) {
             tenantsData[firstOriginalDataIndex].current = false;
           }
        }
      }

      // Preserved React 18 safe functional setState
      this.setState((prevState) => {
        let updatedRentalUnits = prevState.rentalUnits.map((ru) => {
          if (ru.id === targetRentalUnitId) {
            return {
              ...ru,
              tenantsData: [...tenantsData],
            };
          }
          return ru;
        });

        let field = 'name';
        let rentalunitsorted = updatedRentalUnits.sort((a, b) =>
          (a[field] || '').toString().localeCompare((b[field] || '').toString())
        );

        return { rentalUnits: rentalunitsorted };

      }, () => {
        if (response?.other?.eol) {
          setTimeout(() => {
            this.props.getRentalUnitTenants(this.state.rentalUnits);
            this.getRentsApi();  
          }, 1000);
        }
      });
    } else {
      // Fallback for empty endpoints to prevent frozen loaders
      if(response?.other?.eol){
        setTimeout(() => {
          this.props.getRentalUnitTenants(this.state.rentalUnits);
          this.getRentsApi();  
        }, 1000);
      }
    }
  };

  getRentsApi = () => {
    const { rentalUnits } = this.state;
    const isOwnerMode = this.getIsOwnerMode();
    let allValidTenants = [];

    rentalUnits.forEach((rentalUnit) => {
      if (rentalUnit?.tenantsData?.length > 0) {
        rentalUnit.tenantsData.forEach((tenant) => {
          if (tenant && tenant.vacant === false) {
            allValidTenants.push(tenant);
          }
        });
      }
    });

    if (allValidTenants.length === 0) {
      this.ShowLoader();
      return;
    }

    allValidTenants.forEach((tenant, index) => {
      const isLastTenant = index === allValidTenants.length - 1;

      if (isOwnerMode) {
        // --- MOCK DATA INJECTION FOR CONDO FEES ---
        const mockFeesResponse = {
          status: true,
          statuscode: 200,
          result: [
            {
              id: `mock-fee-${tenant.id}`,
              condoOwnerId: tenant.id,
              startDate: '2023-01-01T00:00:00Z',
              endDate: null,
              maintenanceReserve: 150.00,
              advancePayments: 250.50
            }
          ],
          other: { isLastTenant: isLastTenant }
        };

        // Simulate network latency
        setTimeout(() => {
          this.handle_get_rents(mockFeesResponse);
        }, 250);

      } else {
        // --- ORIGINAL AXIOS CALL FOR RENTS ---
        Autoload.HttpRequestAxios.HttpRequest(
          Autoload.Setting.property_api_base_url + 'rents?offset=0&fetch=100&tenantId=' + tenant.id,
          'GET', null, null, false, true, false, this, 'handle_get_rents',
          { isLastTenant: isLastTenant }, 
          false, '', { Authorization: Autoload.Utils.getAuthToken() }, true
        );
      }
    });
  };

  handle_get_rents(response) {
    const isOwnerMode = this.getIsOwnerMode();

    if(response.status && response.statuscode === 200) {
      this.setState((prevState) => {
        let newRentalUnits = prevState.rentalUnits.map((rentalUnit) => {
          let newTenantsData = rentalUnit?.tenantsData.map((tenant) => {
            if(tenant) {
              if(response?.result?.length > 0) {
                // Dynamically match based on mode
                let tenantRent = response.result.find((rent) => isOwnerMode ? rent.condoOwnerId === tenant.id : rent.tenantId === tenant.id);
                if(tenantRent !== undefined) {
                  return { ...tenant, tenantRent: response.result };
                }
              }
            }
            return tenant;
          });

          return { ...rentalUnit, tenantsData: newTenantsData };
        });

        return { rentalUnits: newRentalUnits };
      }, () => {
        setTimeout(() => {
          this.props.getRentalUnitTenants(this.state.rentalUnits);
        }, 1000);
      });
    }

    if(response?.other?.isLastTenant) {
      this.ShowLoader();
    }
  }

  ShowLoader = () => {
    console.log('ShowLoader');
    
    var loader = document.getElementById('hello-housing-loader');
    if(loader) loader.style.display = 'none';
    var emptyDiv = document.getElementById('empty-main-tenant-page');
    if(emptyDiv) emptyDiv.style.display = 'none';
    var dataDiv = document.getElementById('main-tenant-page');
    if(dataDiv) dataDiv.style.display = 'block';
    this.setState({skeletonLoading: false});
    this.props.loadingTenantsData(false);
  };

  deleteUnit = (unitId) => {
    var loader = document.getElementById('hello-housing-loader');
    if(loader) loader.style.display = 'block';
    
    let btnelement = document.getElementById('unit-delete-modal-footer');
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'RentalUnits/' + unitId,
      'DELETE',
      null,
      btnelement.children[1],
      false,
      true,
      false,
      this,
      'handleDelete',
      { cancelbtn: btnelement.children[0], id: unitId },
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  handleDelete = (response) => {
    if (response.status === false && response.message !== 'Not Found') {
      Autoload.DataHandlerGeneral.GeneralErrorMessage(
        true,
        lang.newKeys.text_error_not_found
      );
    }
    var loader = document.getElementById('hello-housing-loader');
    if(loader) loader.style.display = 'none';

    this.props.DeleteUnit(response.other.id);
    response.other.cancelbtn.click();
    this.bind_rental_unit_list_data();
  };

  setCurrentUnit = (id) => {
    let data = this.props.rentalUnits.filter((rc) => rc.id == id);
    this.setState({ currentUnit: { ...data[0] } });
  };

  changePage = (route, state) => {
    this.props.history.push(route, state);
  };

  toggleEditUnitModal = (id) => {
    this.setCurrentUnit(id);
    this.setState({ editUnitModal: !this.state.editUnitModal });
  };

  toggleDeleteUnitModal = (id) => {
    if (id !== undefined) {
      this.setCurrentUnit(id);
    }
    this.setState({ deleteUnitModal: !this.state.deleteUnitModal });
  };

  toggleAddUnitModal = () => {
    this.setState({ addUnitModal: !this.state.addUnitModal });
  };

  addTenant = (id, startDate, endDate) => {
    this.props.setCurrentTenant(
      {},
      {
        name: '',
        email: '',
        phone: '',
        in: '',
        out: '',
        type: 'private',
        note: '',
        rents: [],
      }
    );
    
    this.setState({emptyTenantGapsData: {
      moveIn: startDate !== null ? startDate : '',
      moveOut: endDate !== null ? endDate : ''
    }})
    this.toggleAddTenantModal(id);
  };

  handleSort = (data, param, ascendingOrder) => {
    const sortedList = data.sort((a, b) => (a[param] || '').toString().localeCompare((b[param] || '').toString()));
    this.props.updateFilteredList(sortedList);
    this.setState({ ascendingOrder: !this.state.ascendingOrder });
  };

  handleSearchChange = (e) => {
    this.props.updateFilteredList(this.props.rentalUnits);
    let show = false;
    if (e.target.value !== '') {
      show = true;
    }
    this.setState({ searchValue: e.target.value, showAllTenants: show }, () => this.filterListBySearch());
  };

  handleDeleteTenant = (response) => {
    if (response.status === false && response.message !== 'Not Found') {
      Autoload.DataHandlerGeneral.GeneralErrorMessage(
        true,
        lang.newKeys.text_error_not_found
      );
    }
    response.other.cancelbtn.click();
    this.bind_rental_unit_list_data();
  };

  filterListBySearch = (e) => {
    let tenantsSearch = filterBySearchBarRentalTenants(this.state.searchValue, this.props.filteredList);
    this.props.updateFilteredList(tenantsSearch);
  };

  toggleAddPropertyModal = () => {
    this.setState({ addPropertyModal: !this.state.addPropertyModal });
  };

  toggleAddPropertyTypeModal = () => {
    this.setState({ addPropertyTypeModal: !this.state.addPropertyTypeModal });
  };

  toggleAddTenantModal = (id) => {
    this.setState({ addTenantModal: !this.state.addTenantModal, currentRentalUnitId: id });
  };

  sortAlphabetically = () => {
    let filteredArray = this.props.filteredList.sort((a, b) =>
      (a['name'] || '').toString().localeCompare((b['name'] || '').toString())
    );
    this.props.updateFilteredList(filteredArray);
  };

  sortReverseAlphabetically = () => {
    let filteredArray = this.props.filteredList.sort((a, b) =>
      (b['name'] || '').toString().localeCompare((a['name'] || '').toString())
    );
    this.props.updateFilteredList(filteredArray);
  };

  checkIsEmpty=(value)=>{
    return (!value || value?.length === 0);
  }

  render() {
    const { addUnitModal, editUnitModal, currentUnit, deleteUnitModal, skeletonLoading, emptyTenantGapsData } = this.state;
    const { filteredList, loadingTenantsDataLoader, isMobile, searchValue } = this.props;
    const rentalUnitsInState = this.state.rentalUnits;
    const isOwnerMode = this.getIsOwnerMode();

    return (
      <>
        <div id="empty-main-tenant-page"></div>
        <div className="main-tenant-page" id="main-tenant-page" style={{ display: 'block' }}>
          
          {(rentalUnitsInState && skeletonLoading === false && loadingTenantsDataLoader === false) &&
            rentalUnitsInState
            .filter((rentalUnit)=> {
              if(this.checkIsEmpty(searchValue)){
                return rentalUnit;
              }else{
                if(rentalUnit?.tenantsData.find((tenant)=> tenant?.name.toString().toLowerCase().includes(searchValue.toString().toLowerCase())) !== undefined){
                  return rentalUnit;
                }else{
                  return rentalUnit?.name.toString().toLowerCase().includes(searchValue.toString().toLowerCase());
                }
              }
            })
            .sort((a,b)=> a.name.toLowerCase().localeCompare(b.name.toLowerCase(), 'de', { numeric: true })).map((unit, index) => {
              return (
                <div key={index}>
                  <TenantRecordRow
                    parent={this}
                    showAll={this.state.showAllTenants}
                    history={this.props.history}
                    handleEditUnit={this.toggleEditUnitModal}
                    handleUnitDelete={this.toggleDeleteUnitModal}
                    handleAddTenant={() => this.addTenant(unit.id)}
                    handleAddEmptyTenant={(startDate= null, endDate=null)=> {
                      this.setState({emptyTenantEdit: true});
                      this.addTenant(unit.id, startDate, endDate);
                    }}
                    TenantsAfterAddModal={this.state.TenantPostAddTenant}
                    unitData={unit}
                    propertySelected={this.props.propertySelected}
                    searchValue={searchValue}
                    isOwnerMode={isOwnerMode}
                  />
                  {filteredList.length - 1 !== index && <Divider />}
                </div>
              );
            })}
            
          {(skeletonLoading || loadingTenantsDataLoader) ?
          [...Array(5)].map((e, i) => 
            <div key={i}>
              <div style={{marginBottom: '29px'}}>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                  <Skeleton visible={true} style={{width: '100px'}}/>
                  <div style={{display: 'flex', justifyContent: 'space-between', width: '180px'}}>
                    <Skeleton visible={true} style={{width: '40px'}}/>
                    <Skeleton visible={true} style={{width: '135px', height: '36px'}}/>
                  </div>
                </div>
                <div style={{marginTop: '29px'}}>
                  <div>
                    <Skeleton visible={true} style={{height: '23px', marginBottom: '10px'}}/>
                    <Skeleton visible={true} style={{height: '75px', marginBottom: '10px'}}/>
                    <Skeleton visible={true} style={{height: '24px', width: '86px'}}/>
                  </div>
                </div>
              </div>
              <div className='divider'/>
            </div>
          )
          :
          this.props.filteredList.length === 0 && this.props.properties.length > 0 && (
            <EmptyStateContainer
              heading={lang.tenant.text_no_rental_units}
              subheading={isOwnerMode ? 'Legen Sie Mieteinheiten an, um Eigentümer zu verwalten.' : 'Legen Sie Mieteinheiten an, um Ihre Mietverhältnisse zu verwalten.'}
              icon={BlueUnitsIcon}
              btnHandler={() => {
                this.toggleAddUnitModal();
              }}
              btnText={lang.tenant.text_add_rental_unit}
            />
          )}
          {this.props.properties.length === 0 && (
            <EmptyStateContainer
              heading={lang.tenant.text_no_rental_units}
              subheading={lang.tenant.text_no_unit_and_property}
              icon={BlueUnitsIcon}
              btnHandler={() => {
                this.toggleAddPropertyTypeModal();
              }}
              btnText={lang.general.text_add_property}
            />
          )}
          
          {addUnitModal &&
          <RentalUnitModal
            record={null}
            edit={false}
            open={addUnitModal}
            toggle={this.toggleAddUnitModal}
            updateStore={this.bind_rental_unit_list_data}
            className="add-rental-unit-modal"
          />}
          {editUnitModal &&
          <RentalUnitModal
            record={currentUnit}
            edit={true}
            open={editUnitModal}
            toggle={this.toggleEditUnitModal}
            updateStore={this.bind_rental_unit_list_data}
            className="add-rental-unit-modal"
          />}
          
          <DeleteModal
            open={deleteUnitModal}
            className="delete-rent-modal"
            toggle={this.toggleDeleteUnitModal}
            record={currentUnit}
            handleDelete={() => this.deleteUnit(currentUnit.id)}
            type={lang.tenant.text_rental_unit}
            modalId="unit-delete-modal-footer"
            showtext={false}
            typeText={
              'Sind Sie sicher, dass Sie diese Mieteinheit löschen wollen? Dadurch werden auch alle gespeicherten Mietverhältnisse und hochgeladene Mieterdokumente dieser Mieteinheit unwiderruflich gelöscht.'
            }
            textShowModal={"Mieteinheit löschen"}
            showDeleteText={false}
          />
          
          <AddPropertyModal
            className="add_proprty_modal"
            edit={false}
            open={this.state.addPropertyModal}
            toggle={() => {
              this.toggleAddPropertyModal();
            }}
            propertyType={this.state.selectedPropertyType}
          />
          {this.state.addPropertyTypeModal &&
          <AddPropertyTypeModal
            className="add_proprty_type_modal"
            open={this.state.addPropertyTypeModal}
            toggle={() => {
              this.toggleAddPropertyTypeModal();
            }}
            next={(selectedPropertyType)=> {
              this.setState({selectedPropertyType});
              this.toggleAddPropertyTypeModal();
              this.toggleAddPropertyModal();
            }}
            history={this.props.history}
          />
          }
          
          {this.state.addTenantModal === true && (
            <AddTenantModal
              updateStore={this.bind_rental_unit_list_data}
              rentalId={this.state.currentRentalUnitId}
              className="add_tenant_modal"
              unitData={filteredList}
              open={this.state.addTenantModal}
              toggle={() => {
                this.toggleAddTenantModal();
                this.setState({emptyTenantEdit: false});
              }}
              emptyTenantGapsData={emptyTenantGapsData}
              rentalUnitsInState={rentalUnitsInState}
              emptyTenantEdit={this.state.emptyTenantEdit}
              isOwnerMode={isOwnerMode}
              showAllTenants={(value) => {
                this.showAllTenantFunction(value);
              }}
              history={this.props.history}
              isMobile={isMobile}
            />
          )}
          <button id='update-tenants-data' style={{display: 'none'}} onClick={()=> this.bind_rental_unit_list_data()}/>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    rentalUnits: state.tenantDataReducer.rentalUnits,
    filteredList: state.tenantDataReducer.filteredList,
    properties: state.generalReducer.allProperties,
    propertySelected: state.generalReducer.property,
    refreshTenantDocumentsData: state.generalReducer.refreshTenantDocumentsData,
    loadingTenantsDataLoader: state.tenantDataReducer.loadingTenantsData
  };
};
const actions = {
  getRentalUnitTenants,
  setCurrentTenant,
  updateFilteredList,
  DeleteUnit,
  setRefreshTenantDocumentsData,
  loadingTenantsData
};
export default connect(mapStateToProps, actions)(FilteredTenantsList);